import { c as _c } from "react/compiler-runtime";
import { nounPluralize, progressiveVerb } from "@utils/data-display";
import { useAppSelector } from "@store/store-helper";
import { isBulkActionProcessingSelector, numberOfUpdatingItemsSelector, shouldShowFailedDialogSelector } from "@store/table/table-selector";
/** Return the bulk dialog content */
export function useGetBulkDialogContent(t0) {
  const $ = _c(12);
  const {
    initial,
    failed,
    confirmButtonText,
    entityType
  } = t0;
  const shouldShowFailedDialog = useAppSelector(shouldShowFailedDialogSelector);
  const isBulkActionProcessing = useAppSelector(isBulkActionProcessingSelector);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    title,
    description
  } = shouldShowFailedDialog ? failed : initial;
  let t1;
  if ($[0] !== confirmButtonText || $[1] !== isBulkActionProcessing) {
    t1 = progressiveVerb({
      verb: confirmButtonText,
      isProgressive: isBulkActionProcessing
    });
    $[0] = confirmButtonText;
    $[1] = isBulkActionProcessing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== entityType || $[4] !== numberOfUpdatingItems) {
    t2 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType
    });
    $[3] = entityType;
    $[4] = numberOfUpdatingItems;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${t2} ${shouldShowFailedDialog ? "failed" : "selected"}`;
  let t4;
  if ($[6] !== description || $[7] !== shouldShowFailedDialog || $[8] !== t1 || $[9] !== t3 || $[10] !== title) {
    t4 = {
      title,
      shouldShowFailedIcon: shouldShowFailedDialog,
      description,
      confirmButtonText: t1,
      selectedEntitiesReport: t3
    };
    $[6] = description;
    $[7] = shouldShowFailedDialog;
    $[8] = t1;
    $[9] = t3;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}